import * as React from "react";

import { Box, Grid, Typography } from "@material-ui/core";
import { ImageField, ImageInput } from "react-admin";

import CatandSubCatInput from "../components/CatandSubCatInput";
import HashtagsInput from "../components/HashtagsInput";
import HiddenInputRA from "../components/HiddenInputRA";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridCreate from "../components/LeftGridCreate";
import PermissionChecker from "../../../components/PermissionChecker";
import ProductValidation from "../../../ValidationRules/ProductValidation";
import RightGridCreate from "../components/RightGridCreate";
import SFBreadCrumbs from "../../../components/SfBreadcrumbs";
import StatusInput from "../components/StatusInput";
import TextInputRA from "../components/TextInputRA";

//import SkipStockInput from "../components/SkipStockInput";

/*
{
  "locale": "en-US",
  "type": "Product",
  "name": "Ear Pod",
  "desc": "description",
  "base_price": 1000,
  "retail_price": 10000,
  "currency": "THB",
  "unit": "Piece",
  "hashtags": [
    "#iphone"
  ],
    "status": "Active",
  "sub_category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "realm_id": "xxxxxx-5902ca0b0257bb14df426921",
  "branch_id": "xxxxxx-5902ca0b0257bb14df426921",
  "action": "upload_image"
*/

const transform = (data) => {
  if (data.sub_category_id === null) {
    delete data.sub_category_id;
  }
  const hashtags = getHashtagStringtoArray(data.hashtags);
  if (hashtags === "") return { ...data };
  else return { ...data, hashtags: getHashtagStringtoArray(data.hashtags) };
};
const getHashtagStringtoArray = (hashtagString) => {
  if (!hashtagString || hashtagString === "") return "";
  const rawHashtags = hashtagString.split(",");

  const result = rawHashtags.map((tag) => {
    tag = tag.trim();
    if (tag[0] !== "#") {
      return "#" + tag;
    }
    return tag;
  });

  return result;
};
export const ProductCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate
        {...props}
        validate={ProductValidation}
        transform={transform}
      >
        <SFBreadCrumbs path="/Management/Products/New Product" />
        <Box style={{ margin: 50 }}>
          <TextInputRA
            placeholder="Code"
            required
            label="Code"
            source="code"
            type="code"
          />
          <TextInputRA
            placeholder="Product name"
            required
            label="Product name"
            source="name"
          />
          <TextInputRA
            placeholder="Description"
            label="Description"
            source="desc"
          />
          <TextInputRA
            placeholder="Price"
            required
            label="Price"
            source="retail_price"
            type="number"
          />

          <HiddenInputRA source="skip_stock" initialValue={true} />
          <CatandSubCatInput required />
          <Typography> Pictures</Typography>

          <ImageInput label="" accept="image/*" source="image">
            <ImageField source="src" title="title" />
          </ImageInput>
          <StatusInput />
          <HashtagsInput />
          {/* <ArrayInput source="hashtags[]">
          <SimpleFormIterator>
            <TextInput source="" label="Tags" />
          </SimpleFormIterator>
        </ArrayInput> */}
          <HiddenInputRA source="type" initialValue="Product" />
          <HiddenInputRA source="currency" initialValue="THB" />
          <HiddenInputRA source="unit" initialValue="Piece" />
        </Box>
      </LeftGridCreate>
      <RightGridCreate />
      <PermissionChecker code="Page.Merchant.Management.Product" write />
    </Grid>
  </LayoutContainer>
);
